import { Api } from '@api';

import { actionCreatorAsync } from '../creator';

import {
	IActionStepsLogCreatePayload,
	IActionStepsLogCreatePayloadDone,
	IActionStepsLogCreatePayloadError,
} from './types';

export const stepsLogCreate = actionCreatorAsync<
	IActionStepsLogCreatePayload,
	IActionStepsLogCreatePayloadDone,
	IActionStepsLogCreatePayloadError
>(
	'stepsLogCreate',
	async (params) => {
		const { stepsLog } = params;
		const { data } = await Api.stepsLog.create({
			body: stepsLog,
		});

		return data;
	},
);
